import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface Props {
  label: string;
  description?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  multiline?: boolean;
}

const SchemaTextField: React.FC<Props> = ({ label, description, value, onChange, placeholder, multiline }) => (
  <Box>
    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', mb: 0.5, fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
    {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F', mb: 0.5 }}>{description}</Typography>}
    <TextField
      fullWidth
      size="small"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      multiline={multiline}
      minRows={multiline ? 2 : undefined}
      InputProps={{ sx: { fontSize: 13, borderRadius: '6px' } }}
    />
  </Box>
);

export default SchemaTextField;
